import {useRef, useCallback, useState} from 'react';

import {copyToClipboard} from 'utils/copy_to_clipboard';

type CopyOptions = {
    successCopyTimeout?: number;

    /**
     * Обязательно передать этот параметр, если хук используется внутри модалки
     */
    appendId?: string;
    text: string;
    trackCallback?: () => void;
};

type CopyResponse = {
    copiedRecently: boolean;
    copyError: boolean;
    onClick: () => void;
};

const DEFAULT_COPY_TIMEOUT = 4000;

export default function useCopyText(options: CopyOptions): CopyResponse {
    const [copiedRecently, setCopiedRecently] = useState(false);
    const [copyError, setCopyError] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    let successCopyTimeout = DEFAULT_COPY_TIMEOUT;
    if (options.successCopyTimeout || options.successCopyTimeout === 0) {
        successCopyTimeout = options.successCopyTimeout;
    }

    const onClick = useCallback(async () => {
        if (options.trackCallback) {
            options.trackCallback();
        }

        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }

        const result = await copyToClipboard(options.text, {
            appendId: options.appendId,
        });

        setCopiedRecently(result);
        setCopyError(!result);

        timerRef.current = setTimeout(() => {
            setCopiedRecently(false);
            setCopyError(false);
        }, successCopyTimeout);
    }, [options, successCopyTimeout]);

    return {
        copiedRecently,
        copyError,
        onClick,
    };
}
